import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { QUOTE_QUESTIONS } from "../../AppConstants";

const rules = {
    //residenceYears: 'required',
    //homeOwnership: 'required',
    //homeType: 'required_if:homeOwnership,' + QUOTE_QUESTIONS.YOUR_HOME.HOME_OWNERSHIP.OWN,
    //liveWithParents: 'required_if:homeOwnership,' + QUOTE_QUESTIONS.YOUR_HOME.HOME_OWNERSHIP.OTHER,
    address: {
        street: 'required',
        city: 'required',
        zipCode: 'required',
    }
};

export const allFieldsValidation = (data, stateCode: string | null = null) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};